import type { SupportTypes } from '@cobliteam/prismic';
import type { BlogPostDocumentDataRelationsItem } from '@cobliteam/prismic/src/types/support-cobli.generated';

export const toSupportRelationItem = (blogPost: SupportTypes.BlogPostDocument): BlogPostDocumentDataRelationsItem => ({
  // The generated `post.data` type narrows to the picked relationship fields, whose values
  // collapse to `never` because `blog_post` isn't registered in the global `@prismicio/client`
  // Content namespace (only herbie-dashboard docs are). The runtime shape is the full document
  // data, which is what consumers read, so we assert to the generated field type.
  post: {
    id: blogPost.id,
    uid: blogPost.uid,
    type: blogPost.type,
    link_type: 'Document',
    isBroken: false,
    data: blogPost.data,
  } as unknown as BlogPostDocumentDataRelationsItem['post'],
});

export const mergeSupportRelations = (
  prismicRelations: BlogPostDocumentDataRelationsItem[] | undefined,
  configRelations: BlogPostDocumentDataRelationsItem[]
): BlogPostDocumentDataRelationsItem[] => {
  const merged = [...(prismicRelations ?? []), ...configRelations];
  const seenUids = new Set<string>();

  return merged.filter((relation) => {
    const uid = relation.post && 'uid' in relation.post ? relation.post.uid : undefined;
    if (!uid || seenUids.has(uid)) return false;
    seenUids.add(uid);
    return true;
  });
};
